import AbstractWizardStep from "./AbstractWizardStep.js";

/**
 * `AbstractRoadmapStep` is a step designed to be rendered within
 * `WizardWithRoadmap`. Its subclasses are supposed to override
 * `getTitle`, `_getSubtitle` and `_getStepContent`. Its content can
 * be filled by the helper functions found in
 * `makeRoadmapStepContent`.
 *
 * @abstract
 */
export default class AbstractRoadmapStep extends AbstractWizardStep {
	constructor({ leftWidget } = {}) {
		super(...arguments);

		this._leftWidget = leftWidget;
	}

	setLeftWidget(leftWidget) {
		this._leftWidget = leftWidget;
	}

	getRenderable() {
		return (html) => {
			html.div(
				{ class: "roadmap-wizard-step" },
				this._renderLeftWidgetOn.bind(this),
				html.div(
					{ class: "wizard-step-wrapper" },
					html.div(
						{ class: "wizard-step-content" },
						this._renderTitleOn.bind(this),
						this._renderSubtitleOn.bind(this),
						this._renderStepContentOn.bind(this),
					),
				),
			);
		};
	}

	_renderLeftWidgetOn(html) {
		if (!this._leftWidget) {
			return;
		}

		html.div({ class: "left-widget" }, this._leftWidget);
	}

	_renderTitleOn(html) {
		html.h2({ class: "step-title" }, this.getTitle());
	}

	_renderSubtitleOn(html) {
		html.div({ class: "step-subtitle" }, this._getSubtitle());
	}

	_renderStepContentOn(html) {
		html.div({ class: "step-content" }, this._getStepContent());
	}

	_getSubtitle() {
		this._subclassResponsibility();
	}

	_getStepContent() {
		this._subclassResponsibility();
	}

	_isCompleted() {
		return true;
	}

	_doSubmit({ onDone }) {
		onDone();
	}
}
